/*
 * Icon Tile — homepage "Explore by X" slider controls.
 *  - Top-right prev/next arrows scroll each collection-grid row.
 *  - Mouse click-and-drag scrolls the row (native touch/scrollbar still work).
 *  - Closes the center dropdown when clicking outside it.
 */
(function () {
  // --- Arrows + outside-click dropdown close (event delegation) ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ico-slider-nav');
    if (btn) {
      var section = btn.closest('[id^="shopify-section"]') || btn.closest('.collection-grid');
      var wrap = section && section.querySelector('.collection-grid__wrapper');
      if (!wrap) return;
      var gap = parseFloat(getComputedStyle(wrap).columnGap) || 16;
      var card = wrap.querySelector('.collection-grid__box');
      var step = card ? card.getBoundingClientRect().width + gap : wrap.clientWidth * 0.8;
      var dir = btn.classList.contains('ico-slider-nav--prev') ? -1 : 1;
      wrap.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      return;
    }
    document.querySelectorAll('.ico-dropdown[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  // --- Click-and-drag to scroll (mouse only) ---
  function enableDrag(wrap) {
    var isDown = false, startX = 0, startScroll = 0, moved = false;

    wrap.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return; // leave touch to native scroll
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = wrap.scrollLeft;
      wrap.classList.add('is-dragging');
    });

    wrap.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) {
        if (!moved) wrap.setPointerCapture(e.pointerId);
        moved = true;
      }
      wrap.scrollLeft = startScroll - dx;
    });

    function end(e) {
      if (!isDown) return;
      isDown = false;
      wrap.classList.remove('is-dragging');
      if (moved && e && e.pointerId != null && wrap.hasPointerCapture(e.pointerId)) {
        wrap.releasePointerCapture(e.pointerId);
      }
    }
    wrap.addEventListener('pointerup', end);
    wrap.addEventListener('pointercancel', end);

    // Swallow the click that follows a real drag so card links don't fire
    wrap.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    // Prevent native image/link ghost-dragging
    wrap.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function init() {
    document.querySelectorAll('.body-template-index .collection-grid__wrapper')
      .forEach(enableDrag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
 * Icon Tile — search-as-mega-menu (desktop), click-to-open.
 * Search icon CLICK toggles the panel (body.ico-search-open). Closes via the
 * ✕ button, Escape, a click outside the panel, or hovering a nav menu item
 * (so it never sits on top of the nav mega menus).
 * Mobile: untouched — the icon still opens the search modal.
 */
(function () {
  function isDesktop() { return window.matchMedia('(min-width: 1100px)').matches; }
  function isOpen() { return document.body.classList.contains('ico-search-open'); }

  function openSearch() {
    document.body.classList.add('ico-search-open');
    var inp = document.querySelector('.ico-hsearch-band .ico-hsearch__input');
    if (inp) setTimeout(function () { inp.focus(); }, 30);
  }
  function closeSearch() {
    document.body.classList.remove('ico-search-open');
  }

  document.addEventListener('click', function (e) {
    var icon = e.target.closest('.header__icon--search');
    if (icon && isDesktop()) {
      e.preventDefault();
      e.stopPropagation(); // beat the search-modal trigger
      isOpen() ? closeSearch() : openSearch();
      return;
    }
    if (!isOpen()) return;
    // single-x: clears the text when present; closes the search when empty
    if (e.target.closest('.ico-hsearch__clear')) {
      var inp2 = document.querySelector('.ico-hsearch-band .ico-hsearch__input');
      if (inp2 && inp2.value === '') { e.preventDefault(); closeSearch(); }
      else if (inp2) setTimeout(function () { inp2.focus(); }, 10);
      return;
    }
    if (!e.target.closest('.ico-hsearch-band')) closeSearch();
  }, true);

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && isOpen()) closeSearch();
  });
})();
